import { FunctionComponent, useEffect } from "react";
import { Button, FormControl, Modal, TextField } from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import useNav from "../../../../hooks/useNav";
import { useForm } from "react-hook-form";
import api from "../../../../utils/api";
import { useParams } from "react-router-dom";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";

export const GrupoSedeEdit: FunctionComponent = () => {
  const { goBack } = useNav();
  const { id } = useParams();
  const { setMensagemSuccess, setMensagemError } = useErrorSuccess();
  const { startLoading, stopLoading, isLoading } = useLoading();

  const getGrupoSede = async () => {
    let req = await api.get<{ descricao: string }>("sede/grupo/" + id);
    setValue("descricao", req?.data?.descricao);
    return;
  };

  const { register, setValue, handleSubmit } = useForm<{ descricao: string }>({
    defaultValues: {
      descricao: null,
    },
  });

  useEffect(() => {
    getGrupoSede();
  }, []);

  const put = handleSubmit(async (values) => {
    startLoading();
    try {
      await api.put("sede/grupo/" + id, values);
      setMensagemSuccess("Alterado com sucesso!");
      goBack();
    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data?.mensagem || 'Erro ao tentar alterar grupo'))
    } finally {
      stopLoading();
    }
  });

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <FormControl fullWidth>
            <TextField
              {...register("descricao")}
              label="Descrição"
              sx={{ width: "100%" }}
            />
          </FormControl>
          <div
            style={{
              display: "flex",
              marginTop: 8,
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button variant="contained" color="success" disabled={isLoading} onClick={put}>
              Salvar
            </Button>
            <Button variant="contained" color="error" onClick={goBack}>
              Cancelar
            </Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  );
};
